<template>

    <div class="user">
      <!--添加任务-->
      <div class="common-seach-wrap">
        <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
          <el-form-item label="档案记录">
            <el-input placeholder="请输入档案记录" v-model="formInline.search">
          
            </el-input>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>

            <el-button v-if="showback"  size="small" type="info" @click="gotoBack">返回上一页</el-button>
          </el-form-item>
  
        </el-form>
      </div>
  
      <div class="common-level-rail">
        <!-- <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加档案管理</el-button> -->
      </div>
  
      <div class="product-content">
        <el-form ref="form" :model="form" label-width="100px">
          <div class="table-wrap">
            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
        
              <el-table-column prop="context" label="档案记录"></el-table-column>

              <el-table-column prop="opUser.nickName" label="前端最后编辑人员"></el-table-column>
            <el-table-column  label="后端最终编辑人员">
              <template slot-scope="scope">
                <div v-if="scope.row.opShopUser &&  scope.row.opShopUser.user_name">{{ scope.row.opShopUser.user_name }}
                <span v-if=" scope.row.opShopUser.real_name">({{ scope.row.opShopUser.real_name }})</span>
                </div>
              </template>
              </el-table-column>


  
              <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
              <el-table-column fixed="right" label="操作" width="90">
                <template slot-scope="scope">
                  <el-button @click="editClick(scope.row)" type="text" size="small">详情</el-button>
                </template>
            </el-table-column>   
            </el-table>
          </div>
        </el-form>
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>
      
      <Edit :open_add="open_edit" :hrecords_log_id="hrecords_log_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    </div>
  </template>
  
  <script>
    import HrecordsApi from '@/api/hrecords.js';
    import Add from './part/add.vue';
    import Edit from './lpart/edit.vue';
  
    export default {
      components: {
        Add,
        Edit,
      },
      inject: ['reload'],
      data() {
        return {
          /*是否加载完成*/
          loading: true,
          /*列表数据*/
          tableData: [],
          /*一页多少条*/
          pageSize: 20,
          /*一共多少条数据*/
          totalDataNumber: 0,
          /*当前是第几页*/
          curPage: 1,
          /*搜索表单对象*/
          form: {},
          formInline: {
            search:""
          },
  
          open_add:false,
          open_edit:false,
          hrecords_id:"",
          dialogVisible:false,
          showback:false,
          hrecords_log_id:0,
        };
      },
      created() {
        console.log('this.$route.query.hrecords_id',this.$route.query.hrecords_id);
        if(this.$route.query.hrecords_id){
            this.formInline.search = this.$route.query.hrecords_id
            this.showback = true;
        }
        /*获取列表*/
        this.getTableList();
      },
      methods: {
        /*返回上一页面*/
         gotoBack(){
            this.$router.back(-1);
        },
        dialogFormVisible(){
          this.dialogVisible = false;
        },
        setting(e){//档案管理标题设置
          // this.categorya_id = e
          this.dialogVisible = true;
        },
         /*关闭添加*/
      closeAdd(e){
        this.open_add=false;
        this.getTableList();
      },
      closeEdit(e){
        this.open_edit=false;
        this.getTableList();
      },
      getData(){
        this.getTableList();
      },
        /*选择第几页*/
        handleCurrentChange(val) {
          this.curPage = val;
          this.getTableList();
        },
  
        /*每页多少条*/
        handleSizeChange(val) {
          this.curPage = 1;
          this.pageSize = val;
          this.getTableList();
        },
  
        /*获取列表*/
        getTableList() {
          let self = this;
          let Params = this.formInline;
          Params.page = self.curPage;
          Params.list_rows = self.pageSize;
          self.loading = true;
          HrecordsApi.log(Params, true)
            .then(data => {
              self.loading = false;
              self.tableData = data.data.list.data;
              self.totalDataNumber = data.data.list.total;
            })
            .catch(error => {
            });
        },
  
        /*搜索查询*/
        onSubmit() {
          this.curPage = 1;
          this.getTableList();
        },
  
        /*添加任务*/
        addClick() {
          this.open_add = true
        },
  
        /*编辑活动*/
        editClick(row) {
          this.hrecords_log_id = row.hrecords_log_id;
          this.open_edit = true
        },
  
        /*删除*/
        deleteClick(row) {
          let self = this;
          self
            .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            .then(() => {
              HrecordsApi.del(
                {
                  hrecords_id: row.hrecords_id
                },
                true
              )
                .then(data => {
                  if (data.code == 1) {
                    self.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.getTableList();
                  } else {
                    self.$message.error('错了哦，这是一条错误消息');
                  }
                })
                .catch(error => {
                });
            })
            .catch(() => {
            });
        }
      }
    };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/plus/hrecords/index/log.vue